import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'dateMatch',
  standalone: false,
})
export class DateMatchPipe implements PipeTransform {
  constructor(private readonly _datePipe: DatePipe) {}

  transform(
    value: string | undefined | Date,
    format = 'EEEE, dd.MM.yyyy',
  ): string | null {
    if (!value) {
      return null;
    }

    return this._datePipe.transform(value, format, '+0200', 'pl_PL');
  }
}
